import React,{ createContext, useContext, useReducer } from 'react';
import { ensureBoolean } from '../../lib/ep';

const PromotionContext = createContext({});

const reducer = (state, action) => {
	switch (action.type) {

	
		default:
			return state;
	}
}

const sortMenus = (menus) => {
	return menus.map((m) => {
		m.open = false;
		return m;
	}).sort((a, b) => {
		return (parseInt(a.pos) < parseInt(b.pos)) ? -1 : 1;
	});
}


function Promotion(promotion,menus) {

	this.promotion = promotion;
	this.menus = sortMenus(menus);

	// this.hasMinPlan = function(minType) {

	//     if (this.account.plan == undefined) return false;

	//     if (parseInt(this.account.plan.plan_type) >= parseInt(minType)) return true;

	//     return false;
	// }
	this.get = function(key) {
		return this[key];
	}

	this.displayAgeRestriction = function () {
		let should_display = ensureBoolean(this.promotion.Promotion.config?.age_restriction?.enabled ?? false);

		const cookie = getCookie(`age_restriction_${this.promotion.Promotion.id}`)

		if (cookie != null) {
			should_display = false;
		}
		return should_display;
	}
}

export const PromotionProvider = (props) => {
	//const [ data, dispatch ] = useReducer(reducer, props.promotion);
	const promotion = new Promotion(props.promotion,props.menus);

	return (
		<PromotionContext.Provider
			value={{
				PromoModel:promotion,
				promotion:props.promotion.Promotion,
			}}
		>
			{props.children}
		</PromotionContext.Provider>
	)
};

export const usePromotion = () => {
	return useContext(PromotionContext);
};